module.exports = __webpack_public_path__ + "static/media/SV.1dac940a.png";